import { memo } from 'react';

import { Loading } from '@/components/core';

export type LoadingProps = object;

// eslint-disable-next-line no-empty-pattern
const ILoadingPage = ({}: LoadingProps) => {
  return (
    <div className="relative flex h-screen w-full items-center justify-center">
      <Loading variant="plain" size="sm" label="Loading ..." />
    </div>
  );
};

export const LoadingPage = memo(ILoadingPage) as typeof ILoadingPage;
